const cities = [
  { name: "Des Moines", zips: "50301–50340" },
  { name: "West Des Moines", zips: "50265–50266" },
  { name: "Ankeny", zips: "50021–50023" },
  { name: "Urbandale", zips: "50322–50323" },
  { name: "Johnston", zips: "50131" },
  { name: "Clive", zips: "50325" },
  { name: "Waukee", zips: "50263" },
  { name: "Altoona", zips: "50009" },
  { name: "Pleasant Hill", zips: "50327" },
  { name: "Norwalk", zips: "50211" },
  { name: "Indianola", zips: "50125" },
  { name: "Grimes", zips: "50111" },
  { name: "Bondurant", zips: "50035" },
  { name: "Polk City", zips: "50226" },
  { name: "Carlisle", zips: "50047" },
  { name: "Runnells", zips: "50237" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your expedited passport order from home or work in Des Moines in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the emergency passport submission.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every expedited passport application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed for your emergency passport.",
  },
];

export default function DesMoinesLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Expedited Passport Services for Des Moines &amp; Central Iowa
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are in Des Moines, West Des Moines, Ankeny, Urbandale, or anywhere in Polk, Dallas, or Warren counties, Fast Passport Center makes emergency and expedited passport processing simple.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Des Moines Office</p>
                  <p className="text-white/60 text-xs mt-0.5">801 Grand Ave, Des Moines, IA 50309</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                By appointment only — sign up on our website first to schedule
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Walk-ins are not accepted. Schedule online then visit our downtown Des Moines office.</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, schedule your appointment to visit our office at <strong className="text-white">801 Grand Ave in downtown Des Moines</strong>. Appointments are required — no walk-ins. Or choose <strong className="text-white">overnight shipping</strong> with our prepaid label from any UPS/FedEx location if you prefer not to visit in person.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Expedited Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve Near Des Moines
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div key={i} className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md">
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in central Iowa — start online, ship overnight from Des Moines, and we handle the rest. No need to drive to the Chicago Passport Agency.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities With Expedited Passport Service</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "Cedar Rapids", href: "/cities/cedar-rapids" },
                    { name: "Iowa City", href: "/cities/iowa-city" },
                    { name: "Davenport", href: "/cities/davenport" },
                    { name: "Sioux City", href: "/cities/sioux-city" },
                    { name: "Waterloo", href: "/waterloo" },
                    { name: "Ames", href: "/cities/ames" },
                    { name: "Dubuque", href: "/cities/dubuque" },
                    { name: "Council Bluffs", href: "/cities/council-bluffs" },
                    { name: "West Des Moines", href: "/cities/west-des-moines" },
                  ].map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}